export const objectStagesDict = {
  en: {
    'under-construction': {
      title: 'Under construction',
    },
  },
  de: {
    'under-construction': {
      title: 'Bauarbeiten im Gange',
    },
  },
  ru: {
    'under-construction': {
      title: 'Недвижимость на этапе строительства',
    },
  },
  tr: {
    'under-construction': {
      title: 'İnşaat aşamasında',
    },
  },
};
